import b from '@constants/Business'
import useT from '@hooks/useTranslation'
import { sellLinks } from '@components/search/formLinks'
import {
    ABOUT_US_PAGE,
    ADD_OFFER_PAGE,
    API_DOCS_PAGE,
    CONTACT_PAGE,
    FIRM_BASE_PAGE,
    INTEGRATION_PAGE,
    NEW_DEALER_ACCOUNT_PAGE,
    NEWS_PAGE,
    PRICING_PAGE,
    PRIVACY_PAGE,
    REGULATIONS_PAGE,
    SITE_MAPS_PAGE,
} from '@constants/routes'
import { CAR_LINK_BASE } from '@constants/searchFormLinks'
import SvgIcon from '@components/shared/svg-icons/SvgIcon'
import CookieSettingsButton from '@components/shared/CookieSettingsButton'

import styles from './Footer.module.css'

const HOST = process.env.NEXT_PUBLIC_HOST

// Stopka serwisu. Kategorie z sellLinks (jak menu serwisu); adresy absolutne jak dotąd.
// Linię oddzielającą daje górna ramka stopki (prop nodiv z layoutów nie jest już potrzebny).
export default function Footer () {
    const groups = [
        { title: 'Samochody.pl', links: [
            [CONTACT_PAGE, 'Pomoc i zgłoszenia'],
            [ABOUT_US_PAGE, 'O nas'],
            [PRICING_PAGE, 'Ceny ogłoszeń'],
            [API_DOCS_PAGE, 'API samochody.pl'],
            [PRIVACY_PAGE, 'Polityka prywatności'],
            [REGULATIONS_PAGE, 'Regulamin serwisu'],
        ], extra: (
            <li><CookieSettingsButton className={styles['link-btn']}>{useT('Ustawienia plików cookie')}</CookieSettingsButton></li>
        ) },
        { title: 'Na skróty', links: [
            [NEWS_PAGE, 'Blog'],
            [FIRM_BASE_PAGE, 'Baza firm'],
            [`${CAR_LINK_BASE}/uzywane`, 'Samochody używane'],
            [`${CAR_LINK_BASE}/nowe`, 'Samochody nowe'],
            [SITE_MAPS_PAGE, 'Mapa strony'],
        ] },
        { title: 'Dla firm', links: [
            [INTEGRATION_PAGE, 'Integracje'],
            [NEW_DEALER_ACCOUNT_PAGE, 'Dodaj nową firmę'],
            [CONTACT_PAGE, 'Zareklamuj się'],
            [ADD_OFFER_PAGE, 'Dodaj ogłoszenie'],
        ] },
    ]

    return (
        <footer className={styles.footer}>
            <div className={styles.container}>
                <div className={styles.grid}>
                    <div className={styles.brand}>
                        <a className={styles.logo} href={HOST}>
                            <img alt="Samochody.pl, strona główna" height="40" loading="lazy" src={`${HOST}/logo/logo-white.svg`} width="139" />
                        </a>
                        <p>{useT('Ogłoszenia motoryzacyjne od osób prywatnych i firm z całej Polski.')}</p>
                    </div>
                    <FooterGroup className={styles.cat} links={sellLinks.map(link => [link.to, link.t])} title="Kategorie" />
                    { groups.map(group => <FooterGroup extra={group.extra} key={group.title} links={group.links} title={group.title} />) }
                </div>
                <div className={styles.bottom}>
                    <span>{b.copyright.replace(/\.$/, '')} samochody.pl. {useT('Wszelkie prawa zastrzeżone')}.</span>
                    <span className={styles.social}>
                        <a href={b.facebook} rel="noopener"><SvgIcon name="facebook" />Facebook</a>
                        <a href={b.instagram} rel="noopener"><SvgIcon name="instagram" />Instagram</a>
                    </span>
                </div>
            </div>
        </footer>
    )
}

function FooterGroup ({ className, extra, links, title }) {
    return (
        <div className={className}>
            <h3>{useT(title)}</h3>
            <ul>
                { links.map(([path, label]) => <FooterLink key={label} label={label} path={path} />) }
                {extra}
            </ul>
        </div>
    )
}

function FooterLink ({ label, path }) {
    return <li><a href={HOST + path}>{useT(label)}</a></li>
}
